// Content for the Médailles Animaux "Le défi" section.
// The +6,6 % figure is an external benchmark from the City of Toronto, not a BCITI | ATNA result.
export type Bi = { fr: string; en: string }

export const CHALLENGE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/93c98c8b-52c7-4277-ab18-64ed3662442f.jpg'

export const challengeCopy = {
  eyebrow: { fr: 'Le défi', en: 'The challenge' },
  line1: { fr: 'Trop de friction.', en: 'Too much friction.' },
  line2: { fr: 'Trop d’animaux', en: 'Too many pets' },
  line3: { fr: 'non enregistrés.', en: 'left unregistered.' },
  body: {
    fr: 'Quand enregistrer ou renouveler est compliqué, la conformité en souffre. Et avec elle : les revenus, la qualité du registre et la capacité à retrouver rapidement un animal.',
    en: 'When registering or renewing is complicated, compliance suffers. And with it: revenue, registry quality and the ability to quickly find a lost pet.',
  },
  imageAlt: {
    fr: 'Une femme remplit des formulaires papier, son golden retriever à ses côtés',
    en: 'A woman filling out paper forms, her golden retriever beside her',
  },
}

export const problemCards: { key: 'friction' | 'visibility' | 'impact'; title: Bi; lines: Bi[] }[] = [
  {
    key: 'friction',
    title: { fr: 'Friction élevée', en: 'High friction' },
    lines: [
      { fr: 'Formulaires papier', en: 'Paper forms' },
      { fr: 'Déplacements', en: 'In-person visits' },
      { fr: 'Renouvellements manuels', en: 'Manual renewals' },
    ],
  },
  {
    key: 'visibility',
    title: { fr: 'Visibilité limitée', en: 'Limited visibility' },
    lines: [
      { fr: 'Registres incomplets', en: 'Incomplete registries' },
      { fr: 'Informations périmées', en: 'Outdated information' },
    ],
  },
  {
    key: 'impact',
    title: { fr: 'Impact direct', en: 'Direct impact' },
    lines: [
      { fr: 'Revenus non perçus', en: 'Uncaptured revenue' },
      { fr: 'Animaux plus difficiles à identifier et à retrouver', en: 'Pets harder to identify and reunite with their owners' },
    ],
  },
]

export const proofCopy = {
  eyebrow: { fr: 'Une preuve concrète', en: 'Concrete proof' },
  value: { fr: '+6,6 %', en: '+6.6%' },
  caption: {
    fr: 'de licences émises après le lancement du programme numérique de Toronto.*',
    en: 'more licences issued after Toronto launched its digital program.*',
  },
  period: {
    fr: 'Comparaison entre juin 2024 et mars 2025 et la même période en 2023-2024.',
    en: 'Comparison June 2024 – March 2025 vs the same period 2023 – 2024.',
  },
  source: { fr: 'Source : Ville de Toronto, rapport 2025.', en: 'Source: City of Toronto, 2025 report.' },
}
